<template>
  <div class="container">
    <div v-if="traerdataparkeados.length">
      <p>
        <span class="display-4">{{ traerdataparkeados.length }}</span> Autos
        parkeados
      </p>
    </div>

    <movement />
    <Busqueda class="mb-5"></Busqueda>

    <div class="row">
      <!--cards-->
      <b-card-group
        deck
        v-for="(auto, index) in traerdataparkeados"
        :key="index"
        class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
      >
        <!--            <b-card  v-if="auto.aparcado" :title="auto.patente"  img-src="https://e7.pngegg.com/pngimages/511/801/png-clipart-sports-car-silhouette-car-compact-car-monochrome-thumbnail.png" :img-alt="auto.patente" img-top img-width="2%" >-->

        <b-card v-if="auto.aparcado" :title="auto.patente" class="my-2 mx-2"
          ><i class="fas fa-car-side fa-5x text-dark my-3"></i>
          <b-card-text>
            <p class="text-left">
              Estac.:
              <span
                ><strong>{{ auto.numeropuesto }}</strong>
              </span>
              Dpto:
              <span
                ><strong>{{ auto.numerodepartamento }}</strong>
              </span>
            </p>

            <p class="text-left">Nombre: {{ auto.nombre }}</p>
            <p class="text-left text-primary">
              entrada<br />
              {{ auto.fechaing | formatofecha(auto.fechaing) }}
            </p>
            <p class="text-left text-danger">
              salida <br />
              {{ auto.fechaing | formatofecha2(auto.fechaing) }}
            </p>

            <div>
              <b-button
                block
                variant="danger"
                @click.prevent="
                  out(auto.idDoc, auto.numeropuesto, auto.fechaing)
                "
              >
                {{ auto.numeropuesto }} -
                {{ auto.patente | mayuscula }}</b-button
              >
            </div>
          </b-card-text>
        </b-card>
      </b-card-group>
    </div>
    <!--/cards-->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Busqueda from "../components/Busqueda.vue";
import Movement from "../components/Movement.vue";
import moment from "moment";
import "moment/locale/es";

export default {
  name: "Home",
  components: {
    Busqueda,
    Movement,
  },
  data() {
    return {
      ordenamiento: [],
      fecha: Date.now(),
      fechasal: Date.now(), //moment().format("h:mm"),
      confirmarsalida: 0,
      tiempotranscurrido: 0,
    };
  },
  computed: {
    traerdataparkeados() {
      return this.$store.getters.enviardataparkeados.filter((datos) => {
        return datos.aparcado === true;
      });
    },
  },
  methods: {
    out(idDoc, npuesto, fechai) {
      console.log(fechai);
      //console.log(moment(fechai).format("LLLL"));
      //const v_fechasal = moment(fechai).format("LLLL");
      //const nojoda = v_fechasal.clone().add(8, "hours");

      //const v_fechasal = fechai.add(8, "hours");
      //console.log(nojoda);

      //console.log(moment(fechaing).format("LLL"));
      //console.log(moment(fechasal).format("LLL"));
      console.log(
        moment(fechai)
          .startOf("hour")
          .fromNow()
      );
      this.confirmarsalida = 0;
      (this.fecha = Date.now()),
        Swal.fire({
          title: "Hora Salida " + moment(this.fecha).format("LLLL"),
          text:
            "Esta parkeado desde hace  " +
            moment(fechai)
              .startOf("minutes")
              .fromNow(),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si. Sácalo",
        }).then((result) => {
          if (result.isConfirmed) {
            this.confirmarsalida = 1;
            this.$store.dispatch("out", idDoc);
            this.$store.dispatch("puestoDisponibilidad", npuesto);
          } else {
            this.fechasal = "";
          }
        });
    },
    mipuesto(npuesto) {
      // se omite
      if (this.confirmarsalida === 1) {
        console.log(this.confirmarsalida);
        console.log(npuesto);
        this.$store.dispatch("puestoDisponibilidad", npuesto);
        this.confirmarsalida = 0;
      }
    },
  },
};
// Consultas que hacer
// 1) luego de registrar el auto que de forma inmediata se ejecute el parkeado
// View caradd y luego view CarParking
// 2) Como se hace una app
// 3) Manejo de la fecha timestamp
//Cuentas
//sitio seguro certificado de seguridad
</script>
